import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJoomlaComponent } from './simple-icons-joomla.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJoomlaComponent ],
    exports:      [ SimpleIconsJoomlaComponent ],
    bootstrap:    []
})
export class SimpleIconsJoomlaModule {}
